import React from 'react';
import { useTranslation } from 'react-i18next';

import { MultiSelectField, SelectField } from '@nicoknoll/forms';

import TranslatableFormField from '../../modules/admin/components/TranslatableFormField.tsx';
import { useSuggestions } from '../../modules/admin/utils.tsx';

const StudyFormatField = () => {
    const { t } = useTranslation('customizations');
    const suggestions = useSuggestions('study_formats');

    return (
        <TranslatableFormField name="studyFormats" multiple>
            <MultiSelectField
                label={t('deinstudiumbb.studyFormatLabel')}
                placeholder={t('deinstudiumbb.studyFormatPlaceholder')}
                options={suggestions}
            />
        </TranslatableFormField>
    );
};

const UniversityTypeField = () => {
    const { t } = useTranslation('customizations');
    const suggestions = useSuggestions('university_types');

    return (
        <TranslatableFormField name="universityTypes" multiple>
            <MultiSelectField
                label={t('deinstudiumbb.universityTypeLabel')}
                placeholder={t('deinstudiumbb.universityTypePlaceholder')}
                options={suggestions}
            />
        </TranslatableFormField>
    );
};

const FieldsOfStudyField = () => {
    const { t } = useTranslation('customizations');
    const suggestions = useSuggestions('fields_of_study');

    return (
        <TranslatableFormField name="fieldsOfStudy" multiple>
            <MultiSelectField
                label={t('deinstudiumbb.fieldsOfStudyLabel')}
                placeholder={t('deinstudiumbb.fieldsOfStudyPlaceholder')}
                options={suggestions}
            />
        </TranslatableFormField>
    );
};

const TopicsField = () => {
    const { t } = useTranslation('customizations');
    const suggestions = useSuggestions('topics');

    return (
        <TranslatableFormField name="topics" multiple>
            <MultiSelectField
                label={t('deinstudiumbb.topicsLabel')}
                placeholder={t('deinstudiumbb.topicsPlaceholder')}
                options={suggestions}
            />
        </TranslatableFormField>
    );
};

const FederalStateField = () => {
    const { t } = useTranslation('customizations');
    const suggestions = useSuggestions('federal_states');

    return (
        <TranslatableFormField name="federalStates" multiple>
            <MultiSelectField
                label={t('deinstudiumbb.federalStateLabel')}
                placeholder={t('deinstudiumbb.federalStatePlaceholder')}
                options={suggestions}
            />
        </TranslatableFormField>
    );
};

const PersonalityTypeField = () => {
    const { t } = useTranslation('customizations');
    const suggestions = useSuggestions('personality_types');

    return (
        <TranslatableFormField name="personalityTypes" multiple>
            <MultiSelectField
                label={t('deinstudiumbb.personalityTypeLabel')}
                placeholder={t('deinstudiumbb.personalityTypePlaceholder')}
                options={suggestions}
            />
        </TranslatableFormField>
    );
};

export interface FormFieldConfig {
    name: string;
    component: React.ComponentType;
    defaultValue: any;
    isTranslatable?: boolean;
}

export const ORGANIZATION_PROFILE_GENERAL_TAB_FORM_FIELD_CONFIGS: FormFieldConfig[] = [
    { name: 'studyFormats', component: StudyFormatField, defaultValue: [], isTranslatable: true },
    { name: 'universityTypes', component: UniversityTypeField, defaultValue: [], isTranslatable: true },
    { name: 'fieldsOfStudy', component: FieldsOfStudyField, defaultValue: [], isTranslatable: true },
    { name: 'topics', component: TopicsField, defaultValue: [], isTranslatable: true },
    { name: 'federalStates', component: FederalStateField, defaultValue: [], isTranslatable: true },
    { name: 'personalityTypes', component: PersonalityTypeField, defaultValue: [], isTranslatable: true },
];
